import { call } from 'typed-redux-saga';
import createOrUpdateCsrSessionCookie from '@spa/lib/auth/createOrUpdateCsrSessionCookie';
import getCsrSession from '@spa/lib/auth/getCsrSession';
import { isEqual } from '@spa/lib/auth/session';
import { select } from 'typed-redux-saga';
import selectOptionalSessionContent from '../../session/selectors/selectOptionalSessionContent';

function* updateCsrSessionSaga(): Generator {
  const session = yield* select(selectOptionalSessionContent);
  if (session === null) {
    return;
  }
  if (
    session.isPersisted ||
    session.tokens !== null ||
    session.favoriteStoreId !== null ||
    session.selectedWishlist !== null ||
    session.showOverheadComponent === false
  ) {
    const cookieSession = getCsrSession();
    if (!isEqual(session, cookieSession)) {
      yield* call(createOrUpdateCsrSessionCookie, session);
    }
  }
}

export default updateCsrSessionSaga;
